import domReady from '@wordpress/dom-ready';

domReady(() => {
	const animatedElements = document.querySelectorAll(
		'.homepage-hero__title, .homepage-hero__intro, .homepage-hero__buttons .wp-block-button__link, .homepage-hero__image, .homepage-hero__circles'
	);

	// First, we pause everything.
	animatedElements.forEach((animatedElem) => {
		animatedElem.classList.add('u-animate-paused');
	});

	// manage threshhold
	let animationThreshold = 0.5;

	if (window.outerHeight >= 600) {
		animationThreshold = 0;
	}

	// Then, we create the IntersectionObserver.
	const animObserver = new IntersectionObserver(
		(entries, observer) => {
			entries.forEach((entry) => {
				// If the element is in the viewport, we remove the u-animate-paused class to animate it.
				if (entry.intersectionRatio >= animationThreshold) {
					entry.target.classList.remove('u-animate-paused');
					observer.unobserve(entry.target);
				} else {
					entry.target.classList.add('u-animate-paused');
					entry.target.classList.add('u-animate-no-delay');
				}
			});
		},
		{
			threshold: [0, 0.5],
		}
	);

	// Then, we observe each of the animated elements.
	animatedElements.forEach((animatedElem) => {
		animObserver.observe(animatedElem);
	});
});
